import { ApiDataAccess, Dictionary, ReadonlyHttpApiRepository, Result } from '@softline/core';
import { inject, Injectable } from '@angular/core';
import { Fattener } from '../types/fattener.model';
import { SOFTLINE_API_GEWICHTSPORTAL_FATTENER } from '../gewichtsportal.api';
import { FattenerQuery } from '../types/fattener-query';

@Injectable()
export class FattenerRepository extends ReadonlyHttpApiRepository<Result<Fattener>, Fattener> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_GEWICHTSPORTAL_FATTENER);
  }

  override getLoadPathParams(params: FattenerQuery): Dictionary<unknown> {
    return { id: params.id };
  }
}
